import React from 'react';
import { Row, Col, Card, CardHeader, Button, CardBody, Alert, Badge, Modal, ModalBody, ModalFooter, ModalHeader, Container } from 'reactstrap';
import { dateFormatter, copyArrayObjByNoRef } from '../../../helper/func';
import { fetchRoles, deleteRole } from '../../../api/Role';
import { fetchRoleFeature } from '../../../api/RoleFeature';
import { Pagination } from '../../../components/Pagination';
import { SearchBox } from '../../../components/SearchBox';
import PageTitle from '../../../components/common/PageTitle';
import { tableDatas } from './roleListData';
import { connect } from 'react-redux';
import { LoadingSpinner } from "../../../components";
import NewRole from './NewRole';

class RoleList extends React.Component {

  static routeName = '/setup/role';

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      errorMessage: "",
      successMessage: "",
      deleteModal: false,
      selectModal: undefined,
      isLoading: false,
      currentPage: 1,
      totalPage: 0,
      rowPerPage: 10,
      totalRecord: 0,
      searchKeywords: "",
      sortBy: "UpdatedDate",
      isAsc: false,
      roleName: "",
      deleteObj: {},
    }
  }

  componentDidMount() {
    this.loadData();
  }

  async loadData(isContinueFetch = false) {
    this.setState({ isLoading: true });
    const { currentPage, rowPerPage, searchKeywords } = this.state;
    const res = await fetchRoles(currentPage, rowPerPage, searchKeywords);
    console.log('fetchRole', res);
    this.setState({
      data: res.records,
      totalRecord: res.totalCount,
      totalPage: Math.ceil(res.totalCount / rowPerPage)
    }, () => isContinueFetch ? this.loadOptions() : this.setState({ isLoading: false }));
  }

  handleModel = (roleKey) => {
    let { data } = this.state;
    let deleteObj = data.filter((itm) => {
      if (itm.roleKey === roleKey) {
        return itm;
      }
    })[0];
    this.setState({
      roleName: deleteObj.roleName,
      deleteObj,
    })
    this.toggle();
  }

  // toggle() {
  //   this.setState({ deleteModal: !this.state.deleteModal });
  // }

  toggle(index) {
    let { deleteModal } = this.state;
    this.setState({ deleteModal: deleteModal === index ? -1 : index });
  }
  // Start Paganation Event
  onClickPageNumber(e, index) {
    e.preventDefault();
    this.setState({ currentPage: index }, () => this.loadData());
  }

  onClickRowPerPage(e) {
    this.setState({
      currentPage: 1,
      rowPerPage: Number(e.target.value),
      totalPage: Math.ceil(this.state.data.length / Number(e.target.value)),
    }, () => this.loadData());
  }
  // End Paganation Event

  // Search  Event
  handleSearch(searchKeyword, wait) {
    this.setState({ searchKeyword }, () => {
      wait ? this.debounceSearching(searchKeyword, 1000) : this.searchByFilter();
    });
  }

  debounceSearching(searchKeyword, time) {
    window.clearInterval(this.setTimeInterval);
    let count = 0;
    this.setTimeInterval = window.setInterval(() => {
      count++;
      if (count === 10) {
        window.clearInterval(this.setTimeInterval);
        this.searchByFilter();
      }
    }, Math.floor(time / 10));
  }

  searchByFilter() {
    this.setState({ currentPage: 1 }, () => this.loadData());
  }

  clearMessages() {
    this.setState({
      errorMessage: "",
      successMessage: ""
    });
  }

  handleEdit = (roleId) => {
    this.props.history.push({ pathname: `${NewRole.routeName}/${roleId}` });
  }

  // async handleDelete() {
  //   let { deleteObj } = this.state;
  //   this.setState({ isLoading: true });
  //   this.clearMessages();
  //   var res = await deleteRole(deleteObj);
  //   if (res) {
  //     this.loadData();
  //     this.setState({ successMessage: "Delete " + deleteObj.roleName + " Successful.", deleteModal: false, isLoading: false });
  //   } else {
  //     this.setState({ errorMessage: res.message, deleteModal: false, isLoading: false });
  //   }
  // }

  async handleDelete(rowObj) {
    this.toggle();
    let roleFeatures = await fetchRoleFeature(rowObj.roleId);

    const res = await deleteRole(rowObj.roleId, rowObj.roleName, roleFeatures.records);
    console.log('res' ,res);
    if (res.status === true) {
      this.setState({
        successMessage: "Role Name has been deleted successfully."
      });
      this.loadData();
    }
    else if (res === 401) {
      this.setState({ isExpired: true })
    } else if (res.message === "NOT" && res.status === false) {
      this.setState({
        errorMessage: "Cannot delete item. It is currently being used by another process."
      })
    }
    else {
      this.setState({
        errorMessage: "Error While Deleting!"
      })
    }
  }

  NewRoleFeature(roleKey) {
    this.props.history.push({ pathname: `/Role/RoleFeature/${roleKey}` });
  }

  New() {
    this.props.history.push({ pathname: NewRole.routeName });
  }

  renderRoleListTable = () => {
    let { data } = this.state;
    // let { feature } = this.props;
    if (data.length <= 0) return <b>No Data To Show</b>;

    return (
      <div className="table-responsive">
        <table className="table table-bordered  table-striped table-hover">
          <thead>
            <tr>
              <th>Status</th>
              <th>Role Name</th>
              <th>Create Date</th>
              <th>Create By</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) =>
              <tr key={idx}>
                <td>
                  {
                    item.active == true ?
                      <Badge theme="success">Active</Badge> :
                      <Badge theme="secondary">Inactive</Badge>
                  }
                </td>
                <td>{item.roleName}</td>
                <td>
                  <span>{dateFormatter(item.createdDate)}</span>
                </td>
                <td>
                  <span>{item.createdBy}</span>
                </td>

                <>

                  <td>
                    <span>
                      <Button style={{ marginTop: "5px" }} color="primary" onClick={() => this.handleEdit(item.roleId, item)} > <i className="fa fa-edit"></i></Button>
                      &nbsp;
                      <Button style={{ marginTop: "5px" }} color="danger" onClick={() => this.toggle(idx)}> <i className="fa fa-trash"></i></Button>
                    </span>
                  </td>
                  <div>
                    <Modal isOpen={this.state.deleteModal === idx} toggle={() => this.toggle(idx)}
                      className={'modal-danger '}>
                      <ModalHeader toggle={() => this.toggle(idx)}>Delete Role Name</ModalHeader>
                      <ModalBody>
                        <p>
                          Are you sure want to delete <strong>{item.roleName}</strong>
                        </p>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="danger" onClick={() => this.handleDelete(item)}>Yes</Button>
                        <Button color="secondary" onClick={() => this.toggle(idx)}>No</Button>
                      </ModalFooter>
                    </Modal>
                  </div>

                </>


              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { totalPage, currentPage, rowPerPage, totalRecord, searchKeyword, isLoading, sortBy, isAsc, roleName, data } = this.state;
    let filteredTableDatas = copyArrayObjByNoRef(tableDatas);
    filteredTableDatas.map(td => {
      if (td.title === 'Action') {
        let items = [];
        td.items.map(itm => {
          if ("Edit" === itm.value) items.push(itm);
          if ("Delete" === itm.value) items.push(itm);
        });
        td.items = items;
      }
    });
    return (
      <>
        <Container fluid className="main-content-container px-4">
          <Row noGutters className="page-header py-4">
            <PageTitle sm="4" title="Role List" className="text-sm-left" />
          </Row>
          <Row >
            {this.state.isLoading && <LoadingSpinner />}
            <Col xs="12" lg="12">
              <Card>
                <CardHeader>
                  <Button color="primary" className="float-right" onClick={() => this.New()} >New Role</Button>
                </CardHeader>
                <CardBody>

                  <SearchBox value={searchKeyword} onSearchKeywordChange={(searchKeyword, wait) => this.handleSearch(searchKeyword, wait)} />
                  <br />
                  {this.state.errorMessage !== "" &&
                    <Alert theme="danger">{this.state.errorMessage}</Alert>
                  }
                  {this.state.successMessage !== "" &&
                    <Alert theme="success">{this.state.successMessage}</Alert>
                  }
                  {this.renderRoleListTable()}
                  <br />
                  {totalRecord > 0 &&
                    <Pagination
                      className=""
                      totalPage={totalPage}
                      currentPage={currentPage}
                      rowPerPage={rowPerPage}
                      totalRecord={totalRecord}
                      besideRangeDisplayed={2}
                      onClickPageNumber={(e, index) => this.onClickPageNumber(e, index)}
                      onClickRowPerPage={(e) => this.onClickRowPerPage(e)}
                    />
                  }
                </CardBody>
              </Card>
            </Col>

          </Row>
        </Container>
      </>
    );
  }
}
function mapStateToProps(state) {
  return { auth: state.auth };
}
export default connect(mapStateToProps)(RoleList);
